import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dropdowns'];

  connect() {
    this.relocate = this.relocate.bind(this);
    this.adjustAlignment = this.adjustAlignment.bind(this);

    if (!this.relocate()) {
      this.element.addEventListener('trix-initialize', this.relocate);
    }
  }

  disconnect() {
    this.element.removeEventListener('trix-initialize', this.relocate);
    this.resizeObserver?.disconnect();
  }

  relocate() {
    if (!this.hasDropdownsTarget) return false;

    const buttonRow = this.element.querySelector('.trix-button-row');
    if (!buttonRow) return false;

    if (this.dropdownsTarget.parentElement !== buttonRow) {
      buttonRow.appendChild(this.dropdownsTarget);
    }

    this.dropdownsTarget.classList.remove('hidden');
    this.dropdownsTarget.classList.add('flex');
    this.element.removeEventListener('trix-initialize', this.relocate);

    this.buttonRow = buttonRow;
    this.adjustAlignment();
    this.resizeObserver = new ResizeObserver(this.adjustAlignment);
    this.resizeObserver.observe(buttonRow);

    return true;
  }

  adjustAlignment() {
    const previousGroup = this.dropdownsTarget.previousElementSibling;
    if (!previousGroup) return;

    const wrapped = this.dropdownsTarget.offsetTop > previousGroup.offsetTop;
    this.dropdownsTarget.classList.toggle('ml-auto', !wrapped);
  }
}
